import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-content-builder-common/brand-kit";
import { getInputStyles } from "@redotech/redo-content-builder-common/brand-kit/utils";
import {
  RedoTextareaInputField,
  RedoTextareaInputFieldProps,
} from "./arbiter-components/input/redo-textarea-input-field";
import * as css from "./brand-kit-text-area-input.module.css";

export const BrandKitTextAreaInput = function BrandKitTextAreaInput({
  brandKit,
  override,
  ...props
}: Omit<RedoTextareaInputFieldProps, "style"> & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
}) {
  const style = getInputStyles(brandKit, override);
  return (
    <RedoTextareaInputField
      className={css.brandKitTextareaInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};
